import { render, staticRenderFns } from "./FormTagModal.vue?vue&type=template&id=68215a4e&scoped=true&"
import script from "./FormTagModal.vue?vue&type=script&lang=js&"
export * from "./FormTagModal.vue?vue&type=script&lang=js&"
import style0 from "./FormTagModal.vue?vue&type=style&index=0&id=68215a4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68215a4e",
  null
  
)

export default component.exports